import { connect } from 'react-redux';

import RecursiveBillingSetupPresentation from './RecursiveBillingSetupPresentation';

import { recursiveBillingSetupActions, invoicesActions } from 'dataflow/billingPortal/actions';

function mapStateToProps(state) {
    const { generateInvoice_status, generateInvoice_requesting, generateInvoice_errorMsg } = state.invoicesReducers;

    const { userPermissions } = state.userManagementReducers;

    return {
        ...state.recursiveBillingSetupReducers,

        generateInvoice_status, generateInvoice_requesting, generateInvoice_errorMsg,
        
        userPermissions
    };
}

function mapDispatchToProps(dispatch) {
    return {
        setMaster: (accountNo) => { dispatch(recursiveBillingSetupActions.setMaster(accountNo)); },
        addAccount: (billingSetupObj) => { dispatch(recursiveBillingSetupActions.addAccount(billingSetupObj)); },
        addMultiAccount: (billingSetupObjList) => { dispatch(recursiveBillingSetupActions.addMultiAccount(billingSetupObjList)); },
        deleteAccount: (billingSetupId) => { dispatch(recursiveBillingSetupActions.deleteAccount(billingSetupId)); },
        deactivateAccount: (billingSetupId) => { dispatch(recursiveBillingSetupActions.deactivateAccount(billingSetupId)); },
        updateAccount: (billingSetupObj) => { dispatch(recursiveBillingSetupActions.updateAccount(billingSetupObj)); },
        generateInvoice: (accountCode, datetime) => { dispatch(invoicesActions.generateInvoice(accountCode, datetime)); },

        getAllBillingSetup: (pageNo, pageSize, sort, filterOptions) => { dispatch(recursiveBillingSetupActions.getAllBillingSetup(pageNo, pageSize, sort, filterOptions)); },
        getBillingSetup: (pageNo, pageSize, sort, filterOptions) => { dispatch(recursiveBillingSetupActions.getBillingSetup(pageNo, pageSize, sort, filterOptions)); },
        getUnbillBillingSetup: (pageNo, pageSize, sort, filterOptions) => { dispatch(recursiveBillingSetupActions.getUnbillBillingSetup(pageNo, pageSize, sort, filterOptions)); },

        getNonautomatedAccountList: () => { dispatch(recursiveBillingSetupActions.getNonautomatedAccountList()); },
        getAutomatedAccountList: () => { dispatch(recursiveBillingSetupActions.getAutomatedAccountList()); },
        removeAutomatedAccounts: (accounts) => { dispatch(recursiveBillingSetupActions.removeAutomatedAccounts(accounts)); },
        addAutomatedAccounts: (accounts) => { dispatch(recursiveBillingSetupActions.addAutomatedAccounts(accounts)); },   
        
        importMassBillingSetup: (files) => { dispatch(recursiveBillingSetupActions.importMassBillingSetup(files)); },

        getRemarks: (accountCode) => { dispatch(recursiveBillingSetupActions.getRemarks(accountCode)); },
        updateRemarks: (remarkObj) => { dispatch(recursiveBillingSetupActions.updateRemarks(remarkObj)); },

        getFullAgentCodeList: (remarkObj) => { dispatch(recursiveBillingSetupActions.getFullAgentCodeList(remarkObj)); },
        getFullProductDetailList: () => { dispatch(recursiveBillingSetupActions.getFullProductDetailList()); },
        getFullProductDetail: (productCode) => { dispatch(recursiveBillingSetupActions.getFullProductDetail(productCode)); }
    };
}

const RecursiveBillingSetup = connect(mapStateToProps, mapDispatchToProps)(RecursiveBillingSetupPresentation);

export default RecursiveBillingSetup;